import './App.css';
import React,{useState} from 'react'
import Section0 from './components/Section0';
import Section1 from './components/Section1';
import Section2 from './components/Section2';
import Section3 from './components/Section3';
import Section4 from './components/Section4';
import Section5 from './components/Section5';
import Section6 from './components/Section6';

function App() {

  const products = window.json; // 

  var [select, setSelect] = useState({ // '-1' === undefined
    material: -1, 
    submaterial: -1, 
    cut: false,
    cut_flag: false,
    roll: false,
    cutStyle: undefined,
    roll_length: -1,
    length: 0,
    height: 0, 
    indents: 0.5,
    logo: 'BirkisLogo',
    amount: 0,
    basicPrice: {
      priceForAmout: 0
    },
    options: {
      by_amount: 1,
      by_length: 1,
      by_width: 1,
      by_color_count: 1
    },
    finalPrice: {},
    colors:{
      main:'',
      other:''
    },
    calculatedPrice: -1,
    optionNames:[],
    created: 0
  });

  const [step, setStep] = useState(0); // step = 0 for future use: filter (comparsion) screen

  const [orders, setOrders] = useState(0)

  // escape Section0 if Storage is not supported
  if ( typeof(Storage) === "undefined" && step === 0) {
    setStep(1)
  }

  // go for product select if cart is empty
  if ( typeof(Storage) !== "undefined" && step === 0) {
    
    let keys = Object.keys(localStorage)
    keys = keys.filter(key => key.match('order-') !== null)

    if (keys.length === 0){
      setOrders(keys.length)
      setStep(1)
    }

    // else: there is some orders - continue to Section0
  }

  function stepSection(step){

    switch (step){
      case 0:
        return(
          <Section0 
          products={products}
          setSelect={setSelect} 
          setStep={setStep}
          step={step}
          key="section0"
        />
        );
      case 1:
        return(
          <Section1 
            select={select} 
            setSelect={setSelect} 
            products={products}
            setStep={setStep}
            step={step}
            orders={orders}
            key="section1"
          />
        );
      case 2:
        return(
          <Section2
            select={select}
            setSelect={setSelect}
            products={products}
            setStep={setStep}
            key="section2"
          />
        );
      case 3:
        return(
          <Section3
            select={select}
            setSelect={setSelect}
            products={products}
            setStep={setStep}
            key="section3"
          />
        );
      case 4:
        return(
          <Section4
            select={select}
            setSelect={setSelect}
            products={products}
            setStep={setStep}
            key="section4"
          />
        )
      case 5:
        return(
          <Section5
            select={select}
            setSelect={setSelect}
            products={products}
            setStep={setStep}
            key="section5"
          />
        );
      case 6:
        return(
          <Section6 
            select={select} 
            setSelect={setSelect} 
            products={products}
            step={step}
            setStep={setStep}
            key="section6"
          />
        );
      default:
        return(
          <h4>404</h4> //todo 404
        )
    }
  }

  return (
    <div className={"calc step-"+step}>
      {stepSection(step)}
    </div>
    
  );
}

export default App;